import { createAppAsyncThunk } from '../../store/extensions';
import { SMALL_PAGE_SIZE } from '../../api';
import { CreateLikeDto, ReplyDto } from '../../common';
import {
  deleteCommentOnStoryCall,
  fetchCommentsForStoryCall,
  fetchRepliesToCommentsOnStoryCall,
  insertCommentOnStoryCall,
  insertReplyToCommentOnStoryCall,
  likeStoryCommentCall,
  reportStoryCommentCall,
  updateCommentOnStoryCall,
  moderatorDeleteCommentOnStoryCall,
  fetchStoryCommentCall,
  fetchReplyToStoryCommentCall,
  moderatorUpdateCommentOnStoryCall,
} from './service';
import { StoryCategory } from '../stories/model';
import { ModeratorUpdateStoryCommentDto } from './model';

export const fetchCommentsForStory = createAppAsyncThunk(
  'stories/commentsOnStory',
  (args: {
    storyId: string;
    xMsContinuationToken?: string;
    numrecs?: number;
  }) => {
    return fetchCommentsForStoryCall(
      args.storyId,
      args.xMsContinuationToken,
      args.numrecs ?? SMALL_PAGE_SIZE
    );
  }
);

export const fetchRepliesToCommentsOnStory = createAppAsyncThunk(
  'stories/repliesToCommentsOnStory',
  (args: {
    storyId: string;
    commentId: string;
    xMsContinuationToken?: string;
    numrecs?: number;
  }) => {
    return fetchRepliesToCommentsOnStoryCall(
      args.storyId,
      args.commentId,
      args.xMsContinuationToken,
      args.numrecs ?? SMALL_PAGE_SIZE
    );
  }
);

export const insertCommentOnStory = createAppAsyncThunk(
  'stories/insertCommentOnStory',
  (args: { storyId: string; data: ReplyDto }) => {
    return insertCommentOnStoryCall(args.storyId, args.data);
  }
);

export const insertReplyToCommentOnStory = createAppAsyncThunk(
  'stories/insertReplyToCommentOnStory',
  (args: { storyId: string; commentId: string; data: ReplyDto }) => {
    return insertReplyToCommentOnStoryCall(
      args.storyId,
      args.commentId,
      args.data
    );
  }
);

export const deleteCommentOnStory = createAppAsyncThunk(
  'stories/deleteComment',
  (args: { storyId: string; commentId: string; parentCommentId: string }) => {
    return deleteCommentOnStoryCall(args.storyId, args.commentId);
  }
);

export const updateCommentOnStory = createAppAsyncThunk(
  'stories/updateComment',
  (args: {
    storyId: string;
    commentId: string;
    replyDto: ReplyDto;
    parentCommentId?: string;
  }) => {
    return updateCommentOnStoryCall(
      args.storyId,
      args.commentId,
      args.replyDto
    );
  }
);

export const  moderatorUpdateCommentOnStory = createAppAsyncThunk(
  'stories/moderator/updateComment',
  (args: {
    storyId: string;
    commentId: string;
    replyDto: ModeratorUpdateStoryCommentDto;
    parentCommentId?: string;
  }) => {
    return moderatorUpdateCommentOnStoryCall(
      args.storyId,
      args.commentId,
      args.replyDto
    );
  }
);

export const reportStoryComment = createAppAsyncThunk(
  'stories/comment/report',
  (args: { storyId: string; commentId: string }) => {
    return reportStoryCommentCall(args.storyId, args.commentId);
  }
);

export const likeStoryComment = createAppAsyncThunk(
  'stories/likeStoryComment',
  (args: {
    storyId: string;
    commentId: string;
    parentCommentId?: string;
    likeDto: CreateLikeDto;
    storyCategory?: StoryCategory;
  }) => {
    return likeStoryCommentCall(args.storyId, args.commentId, args.likeDto);
  }
);

export const moderatorDeleteCommentOnStory = createAppAsyncThunk(
  'stories/moderator/deleteStoryComment',
  (args: { storyId: string; commentId: string; parentCommentId?: string }) => {
    return moderatorDeleteCommentOnStoryCall(args.storyId, args.commentId);
  }
);

export const fetchStoryComment = createAppAsyncThunk(
  'stories/get/storyComment',
  (args: { storyId: string; commentId: string }) => {
    return fetchStoryCommentCall(args.storyId, args.commentId);
  }
);

export const fetchSelectedStoryComment = createAppAsyncThunk(
  'stories/get/storyComment/selected',
  (args: { storyId: string; commentId: string }) => {
    return fetchStoryCommentCall(args.storyId, args.commentId);
  }
);

export const fetchReplyToStoryComment = createAppAsyncThunk(
  'stories/get/replyStoryComment',
  (args: { storyId: string; replyId: string }) => {
    return fetchReplyToStoryCommentCall(args.storyId, args.replyId);
  }
);
